import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { SvgIcon } from '../../../../../common/react/components/SvgIcon';
import { getTranslation } from '../../../../../common/react/utils/translations';
import { PlayerModalVotes } from './player-modal-votes';
import { playerModalSelector } from '../../../store/js/modules/brownlow-tracker/player-modal/selectors';
import { UPDATE_FAVOURITE_PLAYER } from '../../../store/js/modules/brownlow-tracker/leaderboard/actions';
import { isFavouritePlayerSelector } from '../../../store/js/modules/brownlow-tracker/leaderboard/selectors';

export const PlayerModalDetails = ({ player }) => {
    const dispatch = useDispatch();
    const isFavourited = useSelector((state) =>
        isFavouritePlayerSelector(state, player.playerId)
    );
    const playerData = useSelector(playerModalSelector);

    // Link for the player profile button
    const playerProfileLink = () => {
        location = PULSE.app.common.url.getPlayerProfileURL(player.playerId);
    };

    const onPlayerFavouriteClick = (playerId) => {
        dispatch(
            UPDATE_FAVOURITE_PLAYER.request({
                id: playerId,
                providerId: playerId
            })
        );
    };

    return (
        <div className="brownlow-player-modal__player-details-container">
            <div className="brownlow-player-modal__player-details-mobile-background"></div>

            <div className="brownlow-player-modal__player-name-container">
                <span className="brownlow-player-modal__first-name">
                    {playerData.playerId ? player?.playerDetails.givenName : ''}
                </span>
                <span className="brownlow-player-modal__last-name">
                    {playerData.playerId ? player.playerDetails.surname : ''}
                </span>
            </div>

            <div className="brownlow-player-modal__buttons-container">
                <button
                    className="brownlow-player-modal__button"
                    data-favourite-id=""
                    data-favourite-provider-id={player.playerId}
                    onClick={() => onPlayerFavouriteClick(player.playerId)}
                >
                    {!playerData.playerId || !isFavourited ? (
                        <SvgIcon icon="star-outline" className="icon" />
                    ) : (
                        <SvgIcon icon="star-filled" className="icon" />
                    )}
                    {getTranslation('label.favourite')}
                </button>
                <button
                    className="brownlow-player-modal__button"
                    onClick={() => playerProfileLink()}
                >
                    <SvgIcon
                        icon="person"
                        folder="elements"
                        subfolder="stats"
                        className="icon"
                    />
                    {getTranslation('label.stats.playerProfile')}
                </button>
            </div>

            <PlayerModalVotes />
        </div>
    );
};

PlayerModalDetails.propTypes = {
    player: PropTypes.object.isRequired
};
